import { SubAPI } from "./SubAPI";
import {Paginated} from "./Users";
import {ManualScriptInput} from "./ProjectFreeformChange";

export class MiscProducts extends SubAPI {
    list(input: {
        project: number
        offset?: number;
        previewChangeset?: number;
    }) {
        return this.fetcher.get<Paginated<MiscProduct>>("/api/misc-products", input)
    }

    upsert(input: MiscProduct & DimensionedExtras) {
        return this.fetcher.post("/api/misc-product", input)
    }
}


export type MiscProduct = {
    id: number;
    project: number;
    quoteAlternative?: number;

    // only available in quote mode
    keyed?: boolean;
    productKeyed?: boolean;

    product: number;
    productCode: string;
    categoryName: string;

    dimHeight: string;
    dimLength: string;
    dimWidth: string;
    finishCode: string;

    manufacturer: number;
    manufacturerName: string;

    qty: number;
    note: string;

    updatedAt: string;
    archived: boolean;

    logictrl?: {
        edited: boolean;
        error: string | null;
        skipRules: boolean;
        conflictsWithMain: boolean;
    }
}

export type DimensionedExtras = {
    extras?: {
        dimHeight: string;
        dimLength: string;
        dimWidth: string;
        handing: string;
        manualScriptInputs?: ManualScriptInput[],
    }
}